import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";

const optArr = [
  { value: "nrw_average", label: "% NRW average" },
  { value: "extent_of_privatisation", label: "% private" },
  { value: "sheet_utilities_total", label: "Number of utilities" },
];

const TypeDropdown = ({ onChange, selectedType }) => (
  <Select
    classNamePrefix="Select"
    classNames={{ container: () => "Select__container" }}
    onChange={e => onChange(e.value)}
    options={optArr}
    placeholder="Select type..."
    value={optArr.find(o => o.value === selectedType) || null}
    isClearable={false}
    isSearchable={false}
    className="main-type-dropdown"
  />
);

TypeDropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  selectedType: PropTypes.string.isRequired
};

export default TypeDropdown;
